export const addToSet = <T>(set: Set<T>, value: T) => {
  set.add(value);
  return new Set(set);
};

export const removeFromSet = <T>(set: Set<T>, value: T) => {
  set.delete(value);
  return new Set(set);
};
